(() => {
  const initialise = () => document.querySelectorAll('[data-aart-listing]').forEach(root => {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const template = root.querySelector('[data-aart-card-library]');
    const resultsGuard = root.querySelector('[data-aart-results]');
    if (!template || !resultsGuard?.querySelector('.grid-wrapper')) return;
    const library = [...template.content.children];
    // Keep historical filter links working after approved label cleanup.
    const canonicalAliases = {"artist":{"BRYCE":"Bryce Watanasoponwong","BRYCE Watanasoponwong":"Bryce Watanasoponwong"},"materials":{"Acrlyic":"Acrylic","Mixed Media":"Mixed media","Teak Wood":"Teak wood","Pigment Ink":"Pigment ink","Oil Pastel":"Oil pastel","Basalt Stone":"Basalt stone","Cotton Rag Paper":"Cotton rag paper"},"medium":{"Mixed Media":"Mixed media"},"style":{"Conceptural":"Conceptual","Abstract Art":"Abstract","Figurative Art":"Figurative","Minimalist":"Minimalism","Surrealistic":"Surrealism"}};
    const canonicalValue = (key,value) => canonicalAliases[key]?.[value] || value;
    const artworkTypes = {"Acrylic on canvas":"Painting","Oil on canvas":"Painting","Oil on printed paper":"Painting","Painting":"Painting","Drawing":"Drawing","Drawing on paper":"Drawing","Photography":"Photography","Sculpture":"Sculpture","Ceramic, cobalt oxide glaze":"Ceramics","Mixed media":"Mixed media","Mixed media assemblage":"Mixed media"};
    const reviewedTypes = {"artwork-illya-stratum-alone-at-home":"Painting","artwork-illya-stratum-a-glorious-march":"Painting","artwork-illya-stratum-turnmoil":"Painting"};
    const typeValues = data => (data.genre || []).some(value=>/sculpture/i.test(value)) ? ['Sculpture'] : [...new Set((data.medium || []).map(value=>artworkTypes[value]).filter(Boolean))];
    const facts = new Map(library.map(card => {let data={};try {data=JSON.parse(card.dataset.artworkFilters || '{}') || {};} catch {} Object.keys(data).forEach(key=>{if(Array.isArray(data[key]))data[key]=[...new Set(data[key].map(value=>canonicalValue(key,value)))];});data.artwork_type=Array.isArray(data.artwork_type)&&data.artwork_type.length?data.artwork_type:(reviewedTypes[card.dataset.artworkHandle]?[reviewedTypes[card.dataset.artworkHandle]]:typeValues(data));const year=card.dataset.artworkYear || '';if (/^\d{4}$/.test(year)){const n=Number(year);data.period=[n<1990?'Before 1990':`${Math.floor(n/10)*10}s`];}else if(/^undated$/i.test(year)){data.period=['Undated'];}return [card,data];}));
    const results = root.querySelector('[data-aart-results]');
    const shell = results.querySelector('.grid-wrapper').cloneNode(true);
    const layoutStyles = [...results.querySelectorAll(':scope > style')].map(node => node.cloneNode(true));
    const layout = root.dataset.gridType;
    const size = Number(root.dataset.pageSize);
    const sort = root.querySelector('[data-aart-sort]');
    const panel = root.querySelector('[data-aart-facets]');
    const pagination = root.querySelector('[data-aart-pagination]');
    const status = root.querySelector('[data-aart-status]');
    const params = new URLSearchParams(location.search);
    let page = Math.max(1, Number(params.get('page')) || 1);
    const labels = (root.dataset.filterLabels || '').split('|');
    const periodLabels = (root.dataset.periodLabels || 'Before 1990|Undated').split('|');
    const periodFor = value => /^\d{4}$/.test(value) ? (Number(value)<1990?'Before 1990':`${Math.floor(Number(value)/10)*10}s`) : value;
    const keys = ['artist','nationality','artwork_type','materials','style','rarity','availability','period'];
    const oldKeys = ['artist','nationality','genre','medium','materials','style','rarity','availability','period'];
    const facetLabel = key => key==='artwork_type' ? root.dataset.artworkTypeLabel : key==='period' ? root.dataset.periodLabel : labels[oldKeys.indexOf(key)];
    const legacyGenre = new Set(params.getAll('aart_genre'));
    const aliases = {artwork_type:'filter.p.m.custom.medium',period:'filter.p.m.custom.year_created',artist:'filter.p.m.custom.artist_name',nationality:'filter.p.m.custom.artist_ethnicity',medium:'filter.p.m.custom.medium',materials:'filter.p.m.custom.material',style:'filter.p.m.shopify.art-style',rarity:'filter.p.m.custom.rarity'};
    const selected = new Map();
    keys.forEach((key,index) => {
      const options = [...new Set(library.flatMap(card => facts.get(card)[key] || []))].sort((a,b)=>key==='period'?(a==='Undated'?1:b==='Undated'?-1:a==='Before 1990'?-1:b==='Before 1990'?1:a.localeCompare(b)):a.localeCompare(b));
      let initial = params.getAll('aart_'+key).concat(params.getAll(aliases[key] || '__unused'));if(key==='period')initial=initial.concat(params.getAll('aart_year')).map(periodFor);
      if(key==='artwork_type')initial=initial.concat(params.getAll('aart_medium')).map(value=>artworkTypes[canonicalValue('medium',value)] || value);
      initial=initial.map(value=>canonicalValue(key,value));
      selected.set(key,new Set(initial.filter(value=>options.includes(value))));
      if (!panel || !options.length) return;
      const disclosure = document.createElement('details');
      const summary = document.createElement('summary');summary.textContent=facetLabel(key) || key;disclosure.append(summary);
      const group = document.createElement('fieldset');group.setAttribute('aria-label',facetLabel(key) || key);
      const legend = document.createElement('legend');legend.className='sr-only';legend.textContent=facetLabel(key) || key;group.append(legend);
      options.forEach(value => {
        const label=document.createElement('label');const input=document.createElement('input');
        input.type='checkbox';input.value=value;input.dataset.facet=key;input.checked=selected.get(key).has(value);
        const text=document.createElement('span');text.textContent=key==='period'?(value==='Before 1990'?periodLabels[0]:value==='Undated'?periodLabels[1]:value):key==='availability'?(value.charAt(0).toUpperCase()+value.slice(1)):value;
        label.append(input,text);group.append(label);
      });
      disclosure.append(group);panel.append(disclosure);disclosure.open=selected.get(key).size>0;
    });
    const applyParams = url => {
      keys.forEach(key=>{url.searchParams.delete('aart_'+key);if(aliases[key])url.searchParams.delete(aliases[key]);[...selected.get(key)].forEach(value=>url.searchParams.append('aart_'+key,value));});
      url.searchParams.delete('aart_medium');url.searchParams.delete('aart_type');if(!legacyGenre.size)url.searchParams.delete('aart_genre');url.searchParams.delete('aart_year');
      return url;
    };
    if (sort && [...sort.options].some(option => option.value === params.get('sort_by'))) sort.value = params.get('sort_by');
    const originals = [...shell.querySelectorAll('[data-artwork-handle]')];
    const grid = shell.matches('ul') ? shell : shell.querySelector('ul');
    const slots = [...grid.children].filter(node => node.querySelector('[data-artwork-handle]') || node.matches('[data-artwork-handle]'));
    const cardFor = (source, index) => {
      const card = source.cloneNode(true);
      const reference = originals[index % originals.length];
      if (reference) {
        card.className = reference.className;
        const media = card.querySelector('.tile-media-wrapper');
        const refMedia = reference.querySelector('.tile-media-wrapper');
        media.className = refMedia.className;
        if (refMedia.hasAttribute('style')) media.setAttribute('style', refMedia.getAttribute('style'));
        card.querySelector('img').className = reference.querySelector('img').className;
        card.querySelector('img').classList.add('is-complete');
        const label = card.querySelector('.tile-content-wrapper');
        const refLabel = reference.querySelector('.tile-content-wrapper');
        if (label && refLabel) label.className = refLabel.className;
      }
      return card;
    };
    const render = (updateUrl = true, moveFocus = false) => {
      let cards = library.filter(card => (!legacyGenre.size || [...legacyGenre].some(value=>(facts.get(card).genre || []).includes(value))) && keys.every(key => !selected.get(key).size || [...selected.get(key)].some(value => (facts.get(card)[key] || []).includes(value))));
      if (sort?.value === 'title-ascending' || sort?.value === 'title-descending') {
        cards.sort((a,b) => a.dataset.artworkTitle.localeCompare(b.dataset.artworkTitle, document.documentElement.lang, {numeric:true}) * (sort.value === 'title-descending' ? -1 : 1));
      }
      const pages = Math.max(1, Math.ceil(cards.length / size));
      page = Math.min(page, pages);
      const visible = cards.slice((page - 1) * size, page * size);
      const nextShell = shell.cloneNode(true);
      const nextGrid = nextShell.matches('ul') ? nextShell : nextShell.querySelector('ul');
      [...nextGrid.children].filter(node => node.querySelector('[data-artwork-handle]') || node.matches('[data-artwork-handle]')).forEach(node => node.remove());
      nextGrid.removeAttribute('style');
      visible.forEach((source,index) => {
        const card = cardFor(source,index);
        if (['justified','modular','irregular'].includes(layout)) {
          const slot = slots[index % slots.length].cloneNode(false);
          card.tagName === 'LI' && card.setAttribute('role','presentation');
          const inner = document.createElement('div');
          [...card.attributes].forEach(attribute => inner.setAttribute(attribute.name,attribute.value));
          inner.append(...card.childNodes);
          slot.append(inner);
          nextGrid.append(slot);
        } else nextGrid.append(card);
      });
      if (layout === 'justified') {
        const items = [...nextGrid.children];
        const setRatios = (columns,prefix) => {
          const remainder = items.length % columns;
          let offset = 0;
          while (offset < items.length) {
            const count = offset === 0 && remainder ? remainder : Math.min(columns,items.length-offset);
            const row = items.slice(offset,offset+count);
            const ratios = row.map(item => Number(item.firstElementChild.dataset.artworkRatio) || 1);
            const total = ratios.reduce((a,b) => a+b,0);
            row.forEach((item,index) => { item.style.setProperty(`--${prefix}-ratio`,ratios[index]/total);item.style.setProperty(`--${prefix}-items-in-row`,count); });
            offset += count;
          }
        };
        setRatios(Number(root.dataset.mobileColumns),'mobile');
        setRatios(Number(root.dataset.desktopColumns),'desktop');
      }
      results.replaceChildren(...layoutStyles.map(node => node.cloneNode(true)),nextShell);
      if (!cards.length) {
        const empty = document.createElement('p');
        empty.className = 'text-center';
        empty.textContent = document.documentElement.lang === 'th' ? 'ไม่พบผลงาน' : document.documentElement.lang.startsWith('zh') ? '没有符合条件的作品' : 'No matching artworks';
        results.replaceChildren(empty);
      }
      pagination.replaceChildren();
      if (pages > 1) {
        for (let n=1;n<=pages;n++) {
          const link = document.createElement('a');
          const url = applyParams(new URL(location.href));
          url.searchParams.set('page',n);
          link.href = url.pathname + url.search;
          link.textContent = n;
          link.className = 'pagination__item min-touch-target' + (n===page ? ' underline' : '');
          if (n===page) link.setAttribute('aria-current','page');
          pagination.append(link);
        }
      }
      status.textContent = `${cards.length} ${root.dataset.resultLabel || ''} · ${page}/${pages}`;
      if (updateUrl) {
        const url = applyParams(new URL(location.href));
        [['page',page>1 ? page : ''],['sort_by',sort?.value !== 'manual' ? sort?.value : '']].forEach(([key,value]) => value ? url.searchParams.set(key,value) : url.searchParams.delete(key));
        history.replaceState(null,'',url);
      }
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      if (moveFocus) {results.setAttribute('tabindex','-1');results.focus({preventScroll:true});root.scrollIntoView({block:'start',behavior:'auto'});}
    };
    sort?.addEventListener('change',()=>{page=1;render();});
    panel?.addEventListener('change',event=>{const input=event.target;if(!input.matches('input[data-facet]'))return;const values=selected.get(input.dataset.facet);input.checked?values.add(input.value):values.delete(input.value);page=1;render();});
    root.querySelector('[data-aart-clear]')?.addEventListener('click',()=>{legacyGenre.clear();selected.forEach(values=>values.clear());panel?.querySelectorAll('input').forEach(input=>input.checked=false);page=1;render();});
    let navigating = false;
    pagination.addEventListener('click',event => {
      const link = event.target.closest('a');
      if (!link || !pagination.contains(link) || !link.getAttribute('href')) return;
      event.preventDefault();event.stopPropagation();
      if (navigating) return;
      navigating = true;
      page=Number(new URL(link.href).searchParams.get('page')) || 1;render(true,true);
      setTimeout(() => {navigating=false;},350);
    });
    render(false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise);else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();

